import { render } from "./TablaUsuarios.vue?vue&type=template&id=f51a12b0&scoped=true"
import script from "./TablaUsuarios.vue?vue&type=script&lang=js"
export * from "./TablaUsuarios.vue?vue&type=script&lang=js"

import "./TablaUsuarios.vue?vue&type=style&index=0&id=f51a12b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51a12b0"]])

export default __exports__